import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { useQuery } from '@percent/utility'

export const useFetchOptions = ({ programId }: { programId: string }) => {
  const { grantsService } = useServices()

  const {
    data: taskTemplates,
    isLoading: isLoadingQuestions,
    error: questionsError
  } = useQuery(['program', programId, 'form-questions'], grantsService.getAllFormQuestions, { programId })

  return {
    taskTemplates,
    isLoadingQuestions,
    questionsError
  }
}
